export default "__VITE_ASSET__c724f1e8__"